import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthCallbackView, AuthRenewView } from './views';
import { HasClaimDirective } from './directives';
import { AuthInterceptor } from './services';
import { ResetPasswordModalComponent } from './components';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AuthCallbackView,
    AuthRenewView,
    HasClaimDirective,
    ResetPasswordModalComponent,
  ],
  imports: [CommonModule, HttpClientModule, ReactiveFormsModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  exports: [HasClaimDirective, ResetPasswordModalComponent],
})
export class AuthModule {}
